import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Stack, Label, Icon } from '@bingads-webui-react/fabric-control';
import { thridPartyMeasurementTrackingStyles } from '../../styles/third-party-measurement-setting-styles';

const warningMessageDefaultSettings = {
  iconName: 'InfoSolid',
  tagName: _TL_('Note'),
};

export const WarningMessage = (props) => {
  const {
    i18n,
    message,
    customSettings,
    overrideStyles,
  } = props;

  const styles = useMemo(() => ({
    ...thridPartyMeasurementTrackingStyles,
    ...overrideStyles,
  }), [overrideStyles]);

  const settings = {
    ...warningMessageDefaultSettings,
    ...customSettings,
  };

  return (
    <Stack
      style={styles.warningMessage}
      className="third-party-warning-message"
      horizontal
      horizontalAlign="Left"
    >
      <Icon
        iconName={settings.iconName}
        style={styles.warningMessage.icon}
      />
      <Label className="third-party-warning-tag-name">
        {i18n.getString(settings.tagName)}
      </Label>
      <Label className="third-party-warning-message-text" styles={styles.warningMessageText}>
        {message}
      </Label>
    </Stack>
  );
};

WarningMessage.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  message: PropTypes.string.isRequired,
  customSettings: PropTypes.shape({}),
  overrideStyles: PropTypes.shape({}),
};

WarningMessage.defaultProps = {
  customSettings: {},
  overrideStyles: {},
};

